// Palette semantica unica per dashboard: card, tag e grafici condividono questi colori

export const SEMANTIC = {
  danger: '#cf1322',
  warning: '#d46b08',
  success: '#389e0d',
  info: '#1677ff',
  neutral: '#8c8c8c',
} as const;

export type Severity = 'danger' | 'warning' | 'success' | 'info' | 'neutral';

// Colori per id stato ordine (order_statuses)
export const ORDER_STATUS_COLORS: Record<number, string> = {
  1: '#1677ff',   // Nuovo
  2: '#d46b08',   // In Attesa
  3: '#389e0d',   // Confermato
  4: '#722ed1',   // In Lavorazione
  5: '#c41d7f',   // In Produzione
  6: '#08979c',   // Pronto per Spedizione
  7: '#2f54eb',   // Spedito
  8: '#d46b08',   // In Transito
  9: '#7cb305',   // Consegnato
  10: '#d4b106',  // Evaso
  99: '#cf1322',  // Annullato
};

export const SHIPMENT_TYPE_COLORS: Record<string, string> = {
  EXTRA_UE: '#722ed1',
  UE: '#1677ff',
  NAZIONALE: '#389e0d',
};

// Ombra leggera condivisa dalle card della dashboard
export const CARD_SHADOW = '0 1px 2px rgba(0, 0, 0, 0.06)';
